import { render, staticRenderFns } from "./RateAddNew.vue?vue&type=template&id=088f234d"
import script from "./RateAddNew.vue?vue&type=script&lang=js"
export * from "./RateAddNew.vue?vue&type=script&lang=js"
import style0 from "./RateAddNew.vue?vue&type=style&index=0&id=088f234d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports